import { useCallback } from 'react'

import { DefaultSheet, SheetBody, Tabs, TabsContent, TabsList, TabsTrigger } from 'twyne-new.ui'

import { DefaultConsentDBAsProvider } from '@Components/ConsentDBAs'
import TcpaConsentDbaList from '@Components/tcpaConsentDba/List'

import { useTcpaConsentDbaContext } from './Context'
import TcpaConsentDbaHelper from './Helper'
import TcpaConsentDbaPreview from './Preview'

function TcpaConsentDbaModal({ onChange, override, overrideValues }) {
  const { tcpaConsentDbaContextValue: { open, tcpaConsentText, tcpaConsentDba }, setTcpaConsentDbaContextValue } = useTcpaConsentDbaContext()

  const closeModal = useCallback(() => {
    setTcpaConsentDbaContextValue(prevState => ({ ...prevState, open: false }))
  }, [setTcpaConsentDbaContextValue])

  return <>
    <DefaultSheet
      wrapperProps={{ open, onOpenChange: open => !open && closeModal() }}
      title='TCPA Consent DBA'
    >
      <SheetBody>
        <Tabs defaultValue='dbas'>
          <TabsList>
            <TabsTrigger value='dbas'>DBAs</TabsTrigger>
            <TabsTrigger value='helpers'>Helpers</TabsTrigger>
            <TabsTrigger value='preview'>Preview</TabsTrigger>
          </TabsList>
          <TabsContent value='dbas'>
            <TcpaConsentDbaList
              onApply={closeModal}
              onChange={onChange}
              fields={tcpaConsentDba}
              override={override}
              overrideValues={overrideValues}
            />
          </TabsContent>
          <TabsContent value='helpers'>
            <TcpaConsentDbaHelper />
          </TabsContent>
          <TabsContent value='preview'>
            <TcpaConsentDbaPreview dbas={tcpaConsentDba} html={tcpaConsentText} />
          </TabsContent>
        </Tabs>
      </SheetBody>
    </DefaultSheet>
  </>
}

export default function TcpaConsentDba({ children, ...props }) {
  return <DefaultConsentDBAsProvider>
    <TcpaConsentDbaModal {...props} />
  </DefaultConsentDBAsProvider>
}
